<template>
  <div class="container">
   <!--  <nav-bar :leftName="leftName" :rightName="rightName" @leftClick="leftClick()" @rightClick="rightClick()"></nav-bar> -->
    <no-data class="no" v-if="settingData.length === 0" :imgSrc="imgUrl" text="暂无时间设置"></no-data>
    <div class="data-bar-list">
      <data-bar 
        class="list-item" 
        v-for="(item, i) in settingData" 
        :key="i"  
        :index="i" 
        :name="name[i]" 
        :subName="item" 
        :checkedShow="showSelect" 
        :isCancel="isCancel" 
        @changeModel="changeModel" 
        @click.native="itemClick(item, i)"
        @changeSelect="getSelect">
      </data-bar>
    </div>
    <button class="btn-block btn-save" @click="rightClick()" :class="settingData.length === 5 && rightName !== '删除' ? 'btn-disable' : ''">{{rightName}}</button>
    <ttip-select v-if="showSelectTip" @cancel="cancel" @sure="sure" :text="deleteText"></ttip-select>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import NoData from '../../components/NoData/NoData.vue'
import DataBar from './compoments/DataBar.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import Common from '../../assets/js/common.js'
import {
  mapState,
  mapMutations
} from 'vuex'
export default {
  components: {
    NoData,
    NavBar,
    DataBar,
    TtipSelect
  },
  data () {
    return {
      leftName: '返回',
      rightName: '添加',
      name: ['第一次', '第二次', '第三次', '第四次', '第五次'],
      settingData: [],
      showSelect: false,
      isCancel: true,
      select: [],
      model: 1, // 1添加 2修改
      modifyIndex: null,
      imgUrl: Common.staticHref() + 'img/pillsAlerm.jpg',
      showSelectTip: false,
      deleteText: '确定要删除1个服药记录',
      addBack: this.$route.query.addBack
    }
  },
  computed: {
    ...mapState(['pillsTimes'])
  },
  methods: {
    ...mapMutations(['PillsTimes']),
    showDatePicker (value) {
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: '服药时间',
          min: [0, 0, 0],
          max: [23, 59, 59],
          startColumn: 'hour',
          columnCount: 2,
          format: {
            hour: 'hh点',
            minute: 'mm分'
          },
          value,
          onSelect: this.selectHandle,
          onCancel: this.cancelSelect
        })
      } else {
        this.datePicker.$updateProps({
          value
        })
      }
      this.datePicker.show()
    },
    cancel () {
      this.showSelectTip = false
    },
    sure () {
      this.showSelectTip = false
      this.select.forEach((item, index) => {
        this.settingData.splice((item - index), 1)
      })
      this.PillsTimes(this.settingData)
      this.select = []
      this.showSelect = false
      this.isCancel = true
      this.leftName = '返回'
      this.rightName = '添加'
    },
    changeModel (value) {
      if (typeof value === 'number') this.select.push(value)
      this.showSelect = !this.showSelect
      this.isCancel = false
      if (this.showSelect) {
        this.leftName = '取消'
        this.rightName = '删除'
      }
    },
    getSelect (param) {
      if (!param) return
      let checked = param.checked
      let index = param.index
      let _indexof = this.select.indexOf(index)
      if (checked) {
        if (_indexof === -1) this.select.push(index)
      } else {
        if (_indexof !== -1) this.select.splice(_indexof, 1)
      }
    },
    itemClick (value, i) {
      this.model = 2
      this.modifyIndex = i
      let timeArr = []
      if (value) timeArr = value.split(':')
      for (let i = 0; i < 3; i++) {
        if (i === 2) {
          timeArr[i] = 0
        } else {
          timeArr[i] = Number(timeArr[i])
        }
      }
      if (this.rightName !== '删除') {
        this.showDatePicker(timeArr)
      }
    },
    leftClick () {
      if (this.leftName === '取消') {
        this.select = []
        this.showSelect = false
        this.isCancel = true
        this.leftName = '返回'
        this.rightName = '添加'
      } else {
        localStorage.setItem('from', 'pullSetting')
        this.$router.push({path: '/TakePills'})
      }
    },
    rightClick () {
      if (this.rightName === '添加') {
        this.model = 1
        if (this.settingData.length === 5) {
          this.$createToast({
            type: 'correct',
            txt: '最多可添加5次服药提醒',
            time: 1000
          }).show()
          return
        }
        this.showDatePicker()
      } else if (this.rightName === '删除') {
        let selectLen = this.select.length
        if (selectLen === 0) {
          this.$createToast({
            type: 'correct',
            txt: '请选择要移除的元素',
            time: 2000
          }).show()
        } else {
          this.showSelectTip = true
          this.deleteText = '确定要删除' + selectLen + '个服药记录？'
        }
      }
    },
    selectHandle (date, selectedVal, selectedText) {
      let h = selectedVal[0]
      let m = selectedVal[1]
      // 格式拼接
      let selectTime = Common.formateDoubleNumber(h) + ':' + Common.formateDoubleNumber(m)
      // 去重
      if (this.settingData.indexOf(selectTime) > -1) {
        this.$createToast({
          type: 'correct',
          txt: '时间添加/设置重复',
          time: 1000
        }).show()
        return
      }
      // 添加时间设置
      if (this.model === 1) {
        this.settingData.push(selectTime)
        if (this.settingData.length === 5) this.rightName = '添加'
      } else if (this.model === 2) {
        if (typeof this.modifyIndex !== 'number') return
        this.settingData[this.modifyIndex] = selectTime
      }
      this.settingData.sort(function (a, b) {
        return (Common.timeToSec(a) - Common.timeToSec(b))
      })
      this.PillsTimes(this.settingData)
    },
    cancelSelect () {}
  },
  mounted () {
    Common.setTitle('时间设置')
    if (this.addBack) this.$router.back()
    // 获取数据
    if (this.pillsTimes) {
      this.settingData = this.pillsTimes
      if (this.settingData.length === 5) this.rightName = '添加'
    }
  }
}
</script>
<style lang="stylus" scoped>
.data-bar-list
  height  100%
  padding 14px 16px 0
  overflow auto
  .list-item
    margin-bottom 12px
// .btn-disable
//   width 257px
</style>


// WEBPACK FOOTER //
// src/pages/TakePillsSetting/TakePillsSetting.vue